import React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { INDEX_URL } from '../settings/common';
import DashboardPage from '../pages/Main/DashboardPage';
import LoginPage from '../pages/User/LoginPage';
import SignUpPage from '../pages/User/SignUpPage';
import ProfilePage from '../pages/User/ProfilePage';
import ChatPage from '../pages/Chat/ChatPage';
import ChatListPage from '../pages/Chat/ChatListPage';
import WASettingsPage from '../pages/User/WASettingsPage';
import { decrypt } from '../helpers/encryption';
import { showSuccessMessage, showErrorMessage } from '../helpers/flash-messages';

const PrivateRoutes = () => {
    const auth_user = decrypt('__bs_auth_user');
    if (!auth_user) {
        showErrorMessage('You are not authorized to view this page.');
        return <Navigate to={INDEX_URL} />;
    }
    return <Outlet />;
}

const ConfigureRoutes = () => {
    const auth_user = decrypt('__bs_auth_user');
    if (!auth_user) {
        showErrorMessage('You are not authorized to view this page.');
        return <Navigate to={INDEX_URL} />;
    }
    if (!auth_user.is_configure) {
        showErrorMessage('Complete configuration settings before use this feature.');
        return <Navigate to={`${INDEX_URL}dashboard`} />;
    }
    return <Outlet />;
}

const AuthRoutes = () => {
    const auth_user = decrypt('__bs_auth_user');
    return (
        auth_user ? <Navigate to={`${INDEX_URL}chat-list`} /> : <Outlet />
    );
}

const Routings = () => {
    return (
        <Routes>
            {/* Authentication Routes */}
            <Route element={<AuthRoutes />}>
                <Route exact path={INDEX_URL} element={<LoginPage />} />
                <Route exact path={INDEX_URL + 'sign-up'} element={<SignUpPage />} />
            </Route>

            {/* Private Routes for authenticated users */}
            <Route element={<PrivateRoutes />}>
                <Route exact path={INDEX_URL + 'profile'} element={<ProfilePage />} />
                <Route exact path={INDEX_URL + 'wa-settings'} element={<WASettingsPage />} />
                <Route exact path={INDEX_URL + 'dashboard'} element={<DashboardPage />} />
            </Route>

            {/* Configured Routes for users with specific permissions */}
            <Route element={<ConfigureRoutes />}>
                <Route exact path={INDEX_URL + 'chat/:chat_id'} element={<ChatPage />} />
                <Route exact path={INDEX_URL + 'chat-list'} element={<ChatListPage />} />
            </Route>
        </Routes>
    );
};

export default Routings;